// Shared identifiers for the self-serve "Manage Slack Notifications" modal.
// Kept in one place so the modal id used to open it (OrganizationPage) and the
// id it registers under (ButtonAndFormModal) cannot drift, and so the landing
// page and OrganizationPage agree on the auto-open query param.

export const SLACK_NOTIFICATIONS_MODAL_ID = 'manage-slack-notifications'

// Presence of this query param on /users auto-opens the modal once (then it is
// stripped). Set by the /integrations/slack "Connect Slack in Balto" CTA.
export const SLACK_AUTO_OPEN_PARAM = 'openSlackModal'
